<template>
  <swiper :options="swiperOption" class="swiper">
    <!-- slides -->
    <swiper-slide
      v-for="(img) in project.images"
      :key="getKey(img)"
    >
      <img :src="img" class="image" @click="imageZoom(img)" @mouseover="zoomIn=true" @mouseleave="zoomIn=false">
      <i class="ap-Agrandar-imagen zoom-in" v-if="zoomIn" @click="imageZoom(img)"></i>
    </swiper-slide>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>

    <!-- Optional controls -->
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>

</template>

<script>
export default {
  props: {
    project: Object
  },
  data () {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        allowTouchMove: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      zoomIn: false
    }
  },
  methods: {
    getKey (img) {
      return `${img}__${Math.random()}`
    },
    imageZoom (img) {
      if (window.innerWidth > 768) {
        this.$emit('imageZoom', img)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

.swiper-button-next
  background-image: url("~@/assets/img/flecha_derecha.svg")
  background-size: 45px 45px

.swiper-button-prev
  background-image: url("~@/assets/img/flecha_izquierda.svg")
  background-size: 45px 45px

.swiper
  display: flex
  height: $f300px
  width: 100%
  padding-bottom: $f30px

.swiper-slide
  display: flex
  justify-content: center
  align-items: center

.image
  display: flex
  flex-direction: columns
  margin: auto
  min-height: $f300px
  max-height: $f300px
  width: 100%

.zoom-in
  position: absolute
  color: white
  opacity: .5
  font-size: 110px

@media screen and (min-width: 301px) and (max-width: 350px)
  .isMobile .zoom-in
    display: none

@media screen and (min-width: 351px) and (max-width: 400px)
  .isMobile .zoom-in
    display: none

@media screen and (min-width: 401px) and (max-width: 500px)
  .isMobile .zoom-in
    display: none

@media screen and (max-width: 768px)
  .isMobile .zoom-in
    display: none

</style>
